module.exports = __webpack_public_path__ + "f7723382.png";